import { shopperAgentCapabilityEnabled } from "@redotech/redo-merchant-app-common/shopper-agent-enabled";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useContext } from "react";

/**
 * Returns true once team data has loaded. Reclaim setup-guide is always on;
 * Shopper Agent is still gated separately via useShopperAgentEnabled.
 */
export function useAnySetupGuideProductEnabled(): boolean {
  const team = useContext(TeamContext);
  return team != null;
}

export function useShopperAgentEnabled(): boolean {
  const team = useContext(TeamContext);
  if (!team) {
    return false;
  }
  return shopperAgentCapabilityEnabled(team);
}
